<template>
<!-- 
The has a global class prop but no class for each option.
We added a class attribute to the option data.
Plus: issue to get the value of the input, due to the data-toggle from bootstrap.

Changes:
- Added the `option.classes ? option.classes : ''` to the label class
- Added <style> for success, warning and danger active buttons.
- Removed `data-toggle="buttons"`
- Adapted styles
- Added the `unselectable` prop
- The `label` prop to options can be HTML
-->
  <div class="btn-group-toggle">
    <label v-for="(option, index) in options"
           :key="index"
           class="btn mb-1"
           :class="[{ active: value === option.value }, buttonClasses, option.classes ? option.classes : '']"
           @click.prevent.stop="select(option.value)">
      <!--
      <input :value="option.value" v-model="model" type="radio" id="option1" autocomplete="off" checked="">
      -->
      <input :value="option.value" type="radio" id="option1" autocomplete="off"
        :checked="option.value == value"
      >
      <span v-html="option.label"></span>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'button-radio-group',
    props: {
      options: {
        type: Array,
        description: 'Radio options. Should be an array of objects {value: "", label: ""}',
        default: () => []
      },
      value: {
        type: String,
        description: 'Radio value'
      },
      buttonClasses: {
        type: [String, Object],
        description: 'Inner button css classes'
      },
      unselectable: {
        type: Boolean,
        default: false
      },
      unselectedValue: {
        default: "-1"
      },
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('change', val)
        }
      }
    },
    methods: {
      select(value) {
        if (value === this.value && this.unselectable) {
          this.$emit('change', this.unselectedValue)
        } else if (value !== this.value) {
          this.$emit('change', value)
        }
      },
    }
  }
</script>

<style scoped>

  label {
    margin-left: 3px !important;
  }
  .btn-round {
    border-radius: 1.5rem;
  }
  .btn-group-toggle .btn:not(.active) {
      color: #525f7f;
  }
  .btn-group-toggle .btn {
      background-color: #f6f9fc;
      cursor: pointer;
      box-shadow: none;
      border: 1px solid #f6f9fc;
      margin: 0;
  }
  .btn-group-toggle .btn.active {
    background-color: #5e72e4;
    color: #fff;
  }

  .outline.btn-danger {
    border: 1px solid #f5365c;
  }
  .outline.btn-warning {
    border: 1px solid #fbcf40;
  }
  .outline.btn-info {
    border: 1px solid #11cdef;
  }
  .outline.btn-success {
    border: 1px solid #2dce89;
  }
  .outline.btn-muted {
    border: 1px solid #b4c2cc;
  }

  .active.btn-danger {
    background-color: #f5365c !important;
    border: 1px solid #f5365c !important;
  }
  .active.btn-warning {
    background-color: #fbc340 !important;
    border: 1px solid  #fbc340 !important;  
  }
  .active.btn-info {
    background-color: #11cdef !important;
    border: 1px solid #11cdef !important;
  }
  .active.btn-success {
    background-color: #2dce89 !important;
    border: 1px solid #2dce89 !important;
  }
  .active.btn-muted {
    background-color: #b4c2cc !important;
    border: 1px solid #b4c2cc !important;
  }

</style>
